export default [
  {
    text: "Home",
    path: "/home",
    icon: "home"
  },
  {
    text: "Examples",
    icon: "folder",
    items: [
      {
        text: "Profile",
        path: "/profile"
      },
      {
        text: "Tasks",
        path: "/tasks"
      }
    ]
  }
  ];
